import styled from "styled-components";

export const ActionsManagementContainer = styled.div`
  margin: 20px 0;
  width: 100%;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 610px) {
    padding: 10px;
    height: 150px;
  }
`;
export const ManagementDiv = styled.div`
  width: 100%;
  max-width: 860px;
  height: 100%;
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const AlignContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  @media (max-width: 610px) {
    width: 100%;
    flex-direction: column;
    justify-content: space-around;
  }
`;
